import { ZoomIn, ZoomOut } from "lucide-react";

/**
 * The hour-zoom control shared by the meetings and booking calendars, so both have
 * exactly the same look and behaviour. Sits above the calendar; the calendar also
 * accepts Ctrl+scroll, which this mirrors for machines where the OS eats that gesture.
 */
export function CalendarZoom({
  onZoomOut,
  onZoomIn,
  atMin,
  atMax,
}: {
  onZoomOut: () => void;
  onZoomIn: () => void;
  atMin: boolean;
  atMax: boolean;
}) {
  return (
    <div className="inline-flex items-center gap-1">
      <div className="inline-flex items-center overflow-hidden rounded-full border border-border bg-card shadow-sm">
        <button
          type="button"
          onClick={onZoomOut}
          disabled={atMin}
          title="Show more hours (flatten the rows) — or Ctrl + scroll"
          className="inline-flex h-7 w-7 items-center justify-center text-muted-foreground transition hover:bg-muted hover:text-foreground disabled:opacity-40"
        >
          <ZoomOut className="h-3.5 w-3.5" />
        </button>
        <button
          type="button"
          onClick={onZoomIn}
          disabled={atMax}
          title="Taller rows, fewer hours — or Ctrl + scroll"
          className="inline-flex h-7 w-7 items-center justify-center border-l border-border text-muted-foreground transition hover:bg-muted hover:text-foreground disabled:opacity-40"
        >
          <ZoomIn className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
